module.exports = __webpack_public_path__ + "media/styles/images/png/circle-left-arrow-gray-dark-on-white-d1e65e0d2c7e7178f0ffd002b4c23921.png";